import {Injectable} from '@angular/core';
import {
  CrudService,
  deserialize,
  JsonApiParams,
  JsonApiResponse,
  objectToHttpParams,
  serialize,
} from '@tisa-group/cdk';
import {UmpireGlobalPageElement} from '@tisa-group/models';

import {Observable} from 'rxjs';
import {TisaUmpireHttpService} from '../tisa-umpire-http.service';

@Injectable()
export class GlobalPageElementsService implements CrudService<UmpireGlobalPageElement> {
  constructor(readonly http: TisaUmpireHttpService) {}

  list(params?: JsonApiParams): Observable<JsonApiResponse<UmpireGlobalPageElement[]>> {
    return this.http
      .get(`/global_page_elements`, {params: objectToHttpParams(params)})
      .pipe(deserialize());
  }

  update(
    globalPageElement: Partial<UmpireGlobalPageElement>,
    params?: JsonApiParams,
  ): Observable<JsonApiResponse<UmpireGlobalPageElement>> {
    return this.http
      .patch(
        `/global_page_elements/${globalPageElement.id}`,
        serialize({stuff: globalPageElement}),
        {
          params: objectToHttpParams(params),
        },
      )
      .pipe(deserialize());
  }

  fetch(
    fetchIdentifier: string,
    params?: JsonApiParams,
  ): Observable<JsonApiResponse<UmpireGlobalPageElement>> {
    return this.http
      .get(`/global_page_elements`, {
        params: objectToHttpParams({...params, slug: fetchIdentifier}),
      })
      .pipe(deserialize());
  }
}
